<template>
  <div v-if="nextRecording" class="next-recording-display">
    <span class="label">Next Recording:</span>
    <span class="details">{{ formattedDate }}</span>
  </div>
  <!-- If there are no upcoming recordings, this component will render nothing. -->
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'NextRecording',
  computed: {
    ...mapGetters(['nextRecording']),
    formattedDate() {
      if (!this.nextRecording || !this.nextRecording.recordingDate?.toDate) {
        return '';
      }
      const date = this.nextRecording.recordingDate.toDate();
      const options = {
        month: 'long', day: 'numeric',
        hour: 'numeric', minute: '2-digit', hour24: true,
      };
      return new Intl.DateTimeFormat('en-GB', options).format(date);
    },
  },
};
</script>

<style scoped>
.next-recording-display {
  font-family: system-ui, sans-serif;
  font-size: 15px;
  white-space: nowrap;
}
.label {
  font-weight: 500;
  color: #E7643B; /* text-gray-600 */
}
.details {
  font-weight: 750; /* semibold */
  color: var(--color-brand-secondary); /* Dynamic brand-purple */
  margin-left: 8px;
}
</style>